<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="120px" class="EL-Form">
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.vendorCode">
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.prodCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料类型" class="EL-Form-Item">
                       <el-select v-model.trim="pagination.laType" placeholder="请选择" clearable="clearable" filterable style="width:150px">
                            <el-option v-for="item in materialTypeList" :key="item.mtId" :label="item.mtCode + '-' + item.mtName" :value="item.mtCode">{{item.mtCode}}-{{item.mtName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="供应商编码" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.supplierCode"></el-input>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="标签属性编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.labelCode">
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="供应商物料">
                <el-button v-authority="'BACK_MENU9_M4_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU9_M4_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <!-- <el-table-column prop="vmId" label="序号ID" /> -->
                <el-table-column prop="fcCode" label="工厂" />
                <!-- <el-table-column prop="matCode" label="物料编号" /> -->
                <el-table-column prop="supplierCode" label="供应商编码" />
                <el-table-column prop="prodCode" label="物料编号" />
                <el-table-column prop="prodDesc" label="物料描述" />
                <el-table-column prop="laType" label="物料类型编号"/>
                <el-table-column prop="boxQuantity" label="装箱数"/>
                <el-table-column prop="saleFlag" label="是否寄售" :formatter="(row)=> { return row.saleFlag ? '是' : '否' }"/>
                <!-- <el-table-column prop="searchType" label="类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.showFlag == true">明码</span>
                        <span v-if="scope.row.showFlag == false">暗码</span>
                    </template>
                </el-table-column> -->
                <el-table-column prop="updateTime" label="更新时间" />
                <!-- <el-table-column prop="" label="默认库位"/> -->
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU9_M4_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="(add_or_edit = false),(editBoxShow = true), update(scope.row)" plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU9_M4_B3'" type="danger" @click="deleteRow(scope.row.mdId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="680px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-width="110px" :model="mainObj" :rules="rules" ref="mainObj" style="text-align: left;">
                    <el-form-item label="物料编号：" prop="prodCode">
                        <el-input placeholder="请输入" v-model="mainObj.prodCode">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="物料描述：" prop="prodDesc">
                        <el-input placeholder="请输入" v-model="mainObj.prodDesc">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="物料类型：" prop="laType">
                        <el-select v-model.trim="mainObj.laType" placeholder="请选择" clearable="clearable" filterable @change="getLabelMatAll(mainObj.mtCode)">
                            <el-option v-for="item in materialTypeList" :key="item.mtId" :label="item.mtCode + '-' + item.mtName" :value="item.mtCode">{{item.mtCode}}-{{item.mtName}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="装箱数：" prop="boxQuantity">
                        <el-input-number v-model="mainObj.boxQuantity" :min="0"></el-input-number>
                    </el-form-item>
                    <el-form-item label="供应商编码：" prop="supplierCode" >
                        <el-input v-model="mainObj.supplierCode" placeholder="请输入"></el-input>
                    </el-form-item>
                    <el-form-item label="是否寄售：" prop="saleFlag">
                        <el-select v-model="mainObj.saleFlag" placeholder="请选择">
                            <el-option label="是" :value="true"></el-option>
                            <el-option label="否" :value="false"></el-option>
                        </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="默认库位" prop="laType">
                        <el-select v-model="mainObj.laType" placeholder="请选择" clearable="clearable" filterable>
                            <el-option v-for="item in locationList" :key="item.mtId" :label="item.lcCode + '-' + item.lcName" :value="item.lcCode"></el-option>
                        </el-select>
                    </el-form-item> -->
                    <!-- <el-form-item label="标签属性：" prop="labelCode" v-if="add_or_edit == false">
                        <el-select v-model.trim="mainObj.labelCode" placeholder="请选择" clearable="clearable" filterable style="width:150px">
                            <el-option v-for="item in labelAttrList" :key="item.labelId" :label="item.labelCode+'-'+item.labelName" :value="item.labelCode">{{item.labelCode}}-{{item.labelName}}</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否显示：" prop="showFlag" v-if="add_or_edit == false">
                        <el-radio-group v-model.trim="mainObj.showFlag">
                            <el-radio label="true" value="true">明码</el-radio>
                            <el-radio label="false" value="false">暗码</el-radio>
                        </el-radio-group>
                    </el-form-item> -->
                    <!-- <template v-if="add_or_edit">
                        <h-table :headerCellStyle="headerCellStyle" :row-class-name="rowClassName" :data="tableData" style="width: 800px">
                            <!-- <el-table-column align="center" prop="xh" label="序号">
                            </el-table-column> -->
                            <!-- <el-table-column prop="labelCode" label="标签名称">
                            </el-table-column>
                            <el-table-column prop="defaultFlag" label="显示类型">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.defaultFlag == true">明码</span>
                                    <span v-if="scope.row.defaultFlag == false">暗码</span>
                                </template>
                            </el-table-column> -->
                            <!-- <el-table-column fixed="right" label="操作">
                                <template slot-scope="scope">
                                    <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" type="text" size="small">
                                        移除
                                    </el-button>
                                    <el-button @click.native.prevent="add_twoTableDelete()" type="text" size="small">
                                        添加
                                    </el-button>
                                </template>
                            </el-table-column> -->
                        <!-- </h-table>
                    </template>-->
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="tableData = [], editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "vendorLabel",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    prodCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    prodDesc: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    laType: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    labelCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    showFlag: [{
                        required: true,
                        message: "请选择",
                        trigger: "blur",
                    }, ],
                    boxQuantity: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    supplierCode:[{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {
                    createTime: "",
                    searchType: "80",
                    prodDesc: "",
                    prodCode: "",
                    laType: "",
                    updateTime: "",
                    fcCode: "",
                    mdId: "",
                    boxQuantity: undefined,
                    supplierCode: "",
                    saleFlag: ""
                },
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    // vendorCode: "",
                    // matCode: "",
                    // mtCode: "",
                    // labelCode: "",
                    prodCode:"",
                    laType:"",
                    searchType:"80",
                    supplierCode: ""
                },
                mainData: [],

                materialTypeList: [], //物料类型
                materialList: [], //物料
                vendorList: [], //供应商
                labelMatList: [], //标签属性
                labelAttrList: [],


                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注

                tableData: [],

                //物料编号loading
                loading: false,
                mtCode: "",
                // 输入框延时加载
                isSetTimeout: null,
                locationList: [],
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/sysMaterialDeploy/getSysMaterialDeploy",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            update(row) {
                var showFlag = row.showFlag ? "true" : "false";
                this.mainObj = {
                    searchType: row.searchType,
                    prodDesc: row.prodDesc,
                    prodCode: row.prodCode,
                    laType: row.laType,
                    fcCode: row.fcCode,
                    mdId: row.mdId,
                    createTime: row.createTime,
                    updateTime: row.updateTime,
                    boxQuantity: row.boxQuantity,
                    supplierCode: row.supplierCode,
                    saleFlag: row.saleFlag,
                }
            },
            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                // this.getLocationList();
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    this.getAuxiMaterialData();
                }
            },
            //新增
            add() {
                this.$refs.mainObj.validate((valid) => {
                if(!valid) return
                var paramsObj = {
                    searchType: "80",
                    prodDesc: this.mainObj.prodDesc,
                    prodCode: this.mainObj.prodCode,
                    laType: this.mainObj.laType,
                    fcCode: localStorage.getItem("fcCode") || "",
                    boxQuantity: this.mainObj.boxQuantity,
                    supplierCode: this.mainObj.supplierCode,
                    saleFlag: this.mainObj.saleFlag,
                    // mdId: "",
                    // createTime: "",
                    // updateTime: "",
                }
                console.log(paramsObj);
                this.$http
                        .request({
                            // url: "/api/sysMaterialDeploy/insertSysMaterialDeploy",
                            url: "/api/sysMaterialDeploy/insertSysMaterialDeployVendor",
                            method: "POST",
                            showLoading: true,
                            data: paramsObj
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "material：物料类型新增成功";
                                this.editBoxShow = false;
                                this.tableData = [];
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "material：物料类型新增失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.prodCode +
                                "\t mtName" +
                                this.mainObj.prodDesc;
                            this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                })
            },
            //编辑
            editRow() {
                this.$refs.mainObj.validate((valid) => {
                if(!valid) return
                this.$http
                    .request({
                        url: "/api/sysMaterialDeploy/updateSysMaterialDeploy",
                        method: "POST",
                        showLoading: true,
                        data: this.mainObj,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "编辑成功！",
                                type: "success",
                            });
                            this.logRemarks = "vendorLabel：供应商物料编辑成功";
                            this.editBoxShow = false;
                            this.tableData = [];
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "vendorLabel：供应商物料编辑失败";
                        }
                        this.logContent = "smId：" + this.mainObj.smId
                        this.systemLog();
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
                })
            },
            //编辑修改备注
            updatetext(row) {
                this.$http
                    .request({
                        url: "/api/vendorLabel/updateVendorLabelRemark",
                        method: "POST",
                        showLoading: true,
                        data: row,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "编辑成功！",
                                type: "success",
                            });
                            this.logRemarks = "vendorLabel：供应商物料备注编辑成功";
                            this.editBoxShow = false;
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: "编辑失败！",
                            });
                            this.logRemarks = "vendorLabel：供应商物料备注编辑失败";
                        }
                        this.logContent = "vmId：" + row.vmId
                        this.systemLog();
                        this.getAuxiMaterialData();
                    })
                    .catch((error) => {
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            },
            //删除
            deleteRow(mdId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/sysMaterialDeploy/deleteSysMaterialDeploy",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    mdId: mdId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "vendorLabel：供应商物料删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "vendorLabel：供应商物料删除失败";
                                }
                                this.logContent = "mdId：" + mdId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            tabClick(row) {
                this.$set(row, "clicktext", true);
            },

            //获取物料类型数据
            getMaterialTypeAll() {
                this.$http
                    .request({
                        url: "/api/materialType/getMaterialTypeAll",
                        method: "GET",
                        // params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.materialTypeList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //获取物料数据
            getMaterialAll() {
                this.$http
                    .request({
                        url: "/api/material/getMaterials",
                        method: "GET",
                        params: {
                            mtCode: this.mainObj.matCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.materialList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //获取供应商数据
            getVendorAll() {
                this.$http
                    .request({
                        url: "/api/vendor/getVendorAlls",
                        method: "GET",
                        params: {
                            svCode: this.mainObj.vendorCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.vendorList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 远程搜索供应商编号
             */
            remoteMethodVendor(query) {
                if (query !== '') {
                    this.loading = true;

                    this.mainObj.vendorCode = query;
                    this.getVendorAll();

                    setTimeout(() => {
                        this.loading = false;
                        if (this.vendorList != undefined) {
                            this.vendorList = this.vendorList.filter(item => {
                                return item.vendorCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.vendorList = [];
                }
            },
            //获取数据
            getLabelAttrAll() {
                this.$http
                    .request({
                        url: "/api/labelAttr/getLabelAttrAll",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.labelAttrList = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //获取物料标签数据
            getLabelMatAll(mtCode) {
                this.$http
                    .request({
                        url: "/api/labelMat/getLabelMatAll",
                        method: "GET",
                        params: {
                            mtCode: mtCode,
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.tableData = resp.data.list || [];
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            /**
             * 远程搜索物料编号
             */
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;

                    this.mainObj.matCode = query;
                    this.getMaterialAll();

                    setTimeout(() => {
                        this.loading = false;
                        if (this.materialList != undefined) {
                            this.materialList = this.materialList.filter(item => {
                                return item.mtCode.toLowerCase()
                                    .indexOf(query.toLowerCase()) > -1;
                            });
                        }
                    }, 200);
                } else {
                    this.materialList = [];
                }
            },
            //序号自增 方法
            rowClassName({
                row,
                rowIndex
            }) {
                row.xh = rowIndex + 1;
            },
            //新增表格
            add_twoTableDelete() {
                this.tableData.push({
                    // date: '2016-05-03',
                    // name: '王小虎',
                    // province: '上海',
                    city: '普陀区',
                    address: '上海市普陀区',
                    zip: 200333
                })
            },

            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    // vendorCode: "",
                    // matCode: "",
                    // mtCode: "",
                    // labelCode: "",
                     prodCode:"",
                    laType:"",
                    supplierCode: "",
                    searchType:"80"
                };
                this.getAuxiMaterialData();
            },
            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    prodCode:this.pagination.prodCode,
                    laType:this.pagination.laType,
                    searchType:"80",
                    labelCode: this.pagination.labelCode,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: "/api/sysMaterialDeploy/getSysMaterialDeploy",
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                list.map(item=>{
                    item.saleFlagText = item.saleFlag ? '是' : '否'
                })
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['工厂', '供应商编码', '物料编号', '物料描述', '物料类型编号',  '装箱数', '是否寄售', '更新时间', '创建时间']
                    const filterVal = ['fcCode', 'supplierCode', 'prodCode', 'prodDesc', 'laType', 'boxQuantity', 'saleFlagText', 'updateTime', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '供应商物料'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_vendor_label：导出供应商物料数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "供应商物料",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            /* 获取所有库位 */
            async getLocationList() {
                try {
                    const res = await this.$http
                        .request({
                            url: "/api/location/getLocationAll",
                            method: "GET",
                            params: {
                                fcCode: localStorage.getItem("fcCode") || "",
                            },
                        })
                    if (res.status == 100) {
                        this.locationList = res.data.list || [];
                    }
                } catch (error) {
                    this.locationList = []
                }
            },
            // 供应商编码改变
            async supplierCodeChange(){
                try {
                    if (this.mainObj.supplierCode.trim() === "") {
                        this.$set(this.mainObj, "saleFlag", "")
                        return
                    }
                    const res = await this.$http
                        .request({
                            url: "/api/vendor/getVendorAll",
                            method: "GET",
                            params: {
                                svCode: this.mainObj.supplierCode,
                                pageSize: 1
                            },
                        })
                    if (res.status == 100 && res.data.list && res.data.list.length) {
                        this.$set(this.mainObj, "saleFlag", res.data.list[0].saleFlag)
                    } else {
                        this.$message.error("当前供应商不存在");
                        this.mainObj.supplierCode = ""
                        this.$set(this.mainObj, "saleFlag", "")
                    }
                } catch (error) {
                    this.$set(this.mainObj, "saleFlag", "")
                }
            }
        },
        activated(){
            this.getMaterialTypeAll();
            this.getMaterialAll();
            this.getVendorAll();
            this.getLabelAttrAll();
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped lang="scss">
.el-form {
    .el-input {
        width: 190px;
    }
}
</style>
